/* eslint-disable react/jsx-pascal-case */
import {
  CmpSelectBox,
  CmpButton,
  CmpDatePicker,
} from "../../Component/Common/ToolBox/ToolBox";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { VirtualBinDetail_summary_API } from "../../Server/ApiV2";

import { GetGitterColumns } from "../../Utility/Utilitys";
import moment from "moment";
import useMediaQuery from "@mui/material/useMediaQuery";
import { GetAttributes } from "./VirtualBinDetailAction";

export default function VirtualBinDetail() {
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const LocationFocusOnLoad = useRef(null);
  const [Summary_Grid_Columns, setSummary_Grid_Columns] = useState([
    {
      field: "A_VocTyp",
      headerName: "VocTyp",
      hide: true,
      width: 70,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "VocName",
      headerName: "Voc.Name",
      hide: false,
      width: 140,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "A_VocNo",
      headerName: "VocNo",
      hide: false,
      width: 80,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "A_VocDt",
      headerName: "Date",
      hide: false,
      width: 80,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "A_Loc",
      headerName: "Location",
      hide: true,
      width: 80,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "LocName",
      headerName: "Location",
      hide: false,
      width: 60,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "A_Reason",
      headerName: "Reason",
      hide: true,
      width: 80,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "ReasonName",
      headerName: "ReasonName",
      hide: true,
      width: 100,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "A_Type",
      headerName: "A_Type",
      hide: false,
      width: 70,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "ItmCd",
      headerName: "Item.Code",
      hide: false,
      width: 80,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "ItemName",
      headerName: "Item.Name",
      hide: false,
      width: 280,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "BinCd",
      headerName: "BinCd",
      hide: true,
      width: 80,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "BinName",
      headerName: "Bin.Name",
      hide: false,
      width: 100,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "BaseQty",
      headerName: "Qty",
      hide: false,
      width: 40,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "Type",
      headerName: "Type",
      hide: false,
      width: 70,
      align: "left",
      headerAlign: "left",
    },
  ]);
  const [sSummaryGridRow, setSummaryGridRow] = useState([]);
  const [sSummaryLocation, setSummaryLocation] = useState([]);
  const [sSummaryTransType, setSummaryTransType] = useState([]);
  const [sSummaryObj, setSummaryObj] = useState({
    loc: "",
    dateFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() - 10
    ),
    dateTo: new Date(),
    TransType: "",
  });
  const fSummary_OnChange = (e) => {
    setSummaryObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fLoad = (e) => {
    Get_Load_Grid_Data(
      sSummaryObj.loc,
      sSummaryObj.dateFrom,
      sSummaryObj.dateTo,
      sSummaryObj.TransType
    );
  };
  const Get_Load_Grid_Data = useCallback(
    async (xLoc, xDate1, xDate2, xTrnType) => {
      var vSummaryObj = {
        v_Loc: xLoc,
        v_Date1: moment(xDate1).format("MM/DD/YYYY"),
        v_Date2: moment(xDate2).format("MM/DD/YYYY"),
        v_TrnTyp: xTrnType,
      };
      const vItemSearch = await VirtualBinDetail_summary_API(vSummaryObj);

      if (vItemSearch?.status === 200) {
        if (vItemSearch?.data?.ResultSet?.length > 0) {
          const itemRows = vItemSearch?.data?.ResultSet?.map((obj, i) => ({
            ...obj,
            id: i + 1,
          }));
          setSummaryGridRow(itemRows);
        } else {
          setSummaryGridRow([]);
        }
      }
    },
    []
  );

  useEffect(() => {
    Get_Load_Grid_Data(
      sSummaryObj.loc,
      sSummaryObj.dateFrom,
      sSummaryObj.dateTo,
      sSummaryObj.TransType
    );
  }, [
    sSummaryObj.loc,
    sSummaryObj.dateFrom,
    sSummaryObj.dateTo,
    sSummaryObj.TransType,
    Get_Load_Grid_Data,
  ]);

  useEffect(() => {
    LocationFocusOnLoad.current.focus();
  }, []);

  const fOnLoad = useCallback(async () => {
    let iAttributeResp = await GetAttributes(
      setSummaryLocation,
      setSummaryTransType
    );

    if (Object.keys(iAttributeResp).length !== 0) {
      setSummaryObj((obj) => ({
        ...obj,
        loc: iAttributeResp.Loc[0]?.UId,
        TransType: iAttributeResp.TaxType[0]?.UId,
      }));
    }
  }, []);
  useEffect(() => {
    fOnLoad();
  }, [fOnLoad]);

  useEffect(() => {
    GetGitterColumns(
      setSummary_Grid_Columns,
      "PENDINGBINDETIL",
      Summary_Grid_Columns
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="container-fluid my-3">
      <div className="Instant-picking-head">
        <Grid
          container
          spacing={{ xs: 2, sm: 2, md: 2 }}
          className="align-items-center mt-4"
        >
          <Grid item lg={2} md={4} xs={6}>
            <CmpSelectBox
              xref={LocationFocusOnLoad}
              xLabelText="Location"
              xValue={sSummaryObj.loc}
              xOnChange={(event) => fSummary_OnChange(event)}
              xName={"loc"}
              xData={sSummaryLocation}
              xValueMember={""}
              xDispalyMember={""}
              xError={false}
              xErrorMessage={false}
              xDisable={false}
            />
          </Grid>
          <Grid item lg={2} md={4} xs={6}>
            <CmpSelectBox
              xLabelText="TransType"
              xValue={sSummaryObj.TransType}
              xOnChange={(event) => fSummary_OnChange(event)}
              xName={"TransType"}
              xData={sSummaryTransType}
              xValueMember={""}
              xDispalyMember={""}
              xError={false}
              xErrorMessage={false}
              xDisable={false}
            />
          </Grid>
          <Grid item lg={2} md={4} xs={6} className="bintransfer-data-date">
            <CmpDatePicker
              xLabelText={"From"}
              xValue={sSummaryObj.dateFrom}
              xOnChange={(newValue) => {
                setSummaryObj((obj) => ({
                  ...obj,
                  dateFrom: newValue.$d,
                }));
              }}
              xName={"dateFrom"}
              xError={false}
              xErrorMessage={false}
            />
          </Grid>
          <Grid item lg={2} md={4} xs={6} className="bintransfer-data-date">
            <CmpDatePicker
              xLabelText={"To"}
              xValue={sSummaryObj.dateTo}
              xOnChange={(newValue) =>
                setSummaryObj((obj) => ({ ...obj, dateTo: newValue.$d }))
              }
              xName={"dateTo"}
              xError={false}
              xErrorMessage={false}
            />
          </Grid>

          <Grid
            item
            lg={2}
            md={4}
            xs={12}
            className="bintransfet-data-load-btn"
          >
            <CmpButton
              xbtnName="Load"
              xOnClick={fLoad}
              xVariant="contained"
              xSize="small"
            />
          </Grid>
        </Grid>
        <>
          <Box
            sx={{ height: vMediaQuery ? "50vh" : "70vh", width: "100%" }}
            className="bin-transfer-data"
          >
            <DataGrid
              rowHeight={30}
              headerHeight={40}
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0
                  ? "mui-even-row"
                  : "mui-odd-row"
              }
              sx={{
                border: 1,
                borderColor: "primary.light",
              }}
              rows={sSummaryGridRow}
              columns={Summary_Grid_Columns}
              hideFooter={sSummaryGridRow.length < 100}
              components={{
                Toolbar: vMediaQuery ? "" : GridToolbar,
              }}
            />
          </Box>
        </>
      </div>
    </div>
  );
}
